import { Issue } from './IssueTrackerContext/types'

export function getReportID(
  record?: Issue['reports'][number] | Issue['identifiedFieldIssue']
) {
  if (!record) return undefined
  const report =
    record.__typename === 'IssueToReport'
      ? record.asphaltLot ??
        record.concreteTest ??
        record.concreteTestSet ??
        record.dailyInspectionControlPoint ??
        record.dailyInspectionInspection ??
        record.dailyInspectionPunchList ??
        record.lot
      : record.asphaltLot ??
        record.concreteTest ??
        record.dailyInspectionControlPoint ??
        record.dailyInspectionInspection ??
        record.dailyInspectionPunchList ??
        record.lot
  if (!report) return undefined
  const { globalId } = report
  if (report.__typename === 'AsphaltLot') return report.asphaltLotId ?? globalId
  else if (report.__typename === 'ConcreteTest')
    return report.fieldNumber ?? globalId
  else if (report.__typename === 'ConcreteTestSet')
    return report.testSetId ?? globalId
  else if (report.__typename === 'DailyInspectionControlPoint')
    return report.controlPointId ?? globalId
  else if (report.__typename === 'DailyInspectionInspection')
    return report.inspectionId ?? globalId
  else if (report.__typename === 'DailyInspectionPunchList')
    return report.punchListId ?? globalId
  else if (report.__typename === 'Lot') return report.lotId ?? globalId
  else return globalId
}
